import { render, staticRenderFns } from "./ModalVotantesxPuesto.vue?vue&type=template&id=05833440&scoped=true"
import script from "./ModalVotantesxPuesto.vue?vue&type=script&lang=js"
export * from "./ModalVotantesxPuesto.vue?vue&type=script&lang=js"
import style0 from "./ModalVotantesxPuesto.vue?vue&type=style&index=0&id=05833440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05833440",
  null
  
)

export default component.exports